import { z } from "zod"

export const B2CSignUpSchema = z.object({
  title: z.string().min(1, {
    error: "Title is required!",
  }),
  firstName: z.string().min(1, {
    error: "First name is required!",
  }),
  lastName: z.string().min(1, {
    error: "Last name is required!",
  }),
  email: z.email({
    error: "Email is required",
  }),
  password: z.string().min(1, {
    error: "Password is required!",
  }),
})

export type B2CSignUpForm = z.infer<typeof B2CSignUpSchema>

export const B2BSignUpSchema = z.object({
  companyName: z.string().min(1, {
    error: "Company name is required!",
  }),
  title: z.string().min(1, {
    error: "Title is required!",
  }),
  firstName: z.string().min(1, {
    error: "First name is required!",
  }),
  lastName: z.string().min(1, {
    error: "Last name is required!",
  }),
  email: z.email({
    error: "Email is required",
  }),
  password: z.string().min(1, {
    error: "Password is required!",
  }),
})

export type B2BSignUpForm = z.infer<typeof B2BSignUpSchema>
